import {PaginationParams} from './pagination';

export class AdminSettings {
  paginationParams: PaginationParams = new PaginationParams();
  currentSortHeader: string = '';
  currentSort: string = '';
  search: string = '';
  activeSection: 'continents' | 'countries' | 'cities' | 'hotels' | 'adventures' | 'routes' | 'vouchers' = 'continents';

  constructor(data?: AdminSettings) {
    this.paginationParams = data?.paginationParams ?? new PaginationParams();
    this.currentSortHeader = data?.currentSortHeader ?? '';
    this.currentSort = data?.currentSort ?? '';
    this.search = data?.search ?? '';
    this.activeSection = data?.activeSection ?? 'continents';
  }
}

export class DocumentsSettings {
  paginationParams: PaginationParams = new PaginationParams();
  currentSortHeader: string = '';
  currentSort: string = '';
  search: string = '';

  constructor(data?: Partial<DocumentsSettings>) {
    if (data) {
      this.paginationParams = data.paginationParams ? new PaginationParams(data.paginationParams) : new PaginationParams();
      this.currentSortHeader = data.currentSortHeader || '';
      this.currentSort = data.currentSort || '';
      this.search = data.search || '';
    }
  }
}
